import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingBag, Trash2, ArrowRight } from "lucide-react";
import { getFlowerImage } from "./flowerData";

// --- KẾT NỐI XÁC THỰC FIREBASE ---
import { auth } from "./firebase";

export default function Giohangcuaban() {
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [coupon, setCoupon] = useState("");
  const [discountApplied, setDiscountApplied] = useState(0);
  
  // Tải dữ liệu giỏ hàng ban đầu từ localStorage & Nhúng Font chữ sang trọng giống About page
  useEffect(() => {
    const savedCart = JSON.parse(localStorage.getItem("sellixy_cart")) || [];
    setCart(savedCart);

    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,400&family=Pinyon+Script&family=Montserrat:wght@300;400;500;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  // --- CÁC HÀM XỬ LÝ GIỎ HÀNG THÔ NẰM TẠI CHỖ ---
  const updateCart = (newCart) => {
    setCart(newCart);
    localStorage.setItem("sellixy_cart", JSON.stringify(newCart));
    // Dispatch custom event để MainLayout cập nhật badge
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const changeQuantity = (id, delta) => {
    const newCart = cart.map((item) => {
      if (item.id === id) return { ...item, quantity: Math.max(1, item.quantity + delta) };
      return item;
    });
    updateCart(newCart);
  };

  const removeItem = (id) => {
    const newCart = cart.filter((item) => item.id !== id);
    updateCart(newCart);
  };

  // Tính toán tiền bạc
  const subTotal = cart.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 1), 0);
  const finalTotalOrder = Math.max(0, subTotal - discountApplied);

  const handleApplyCoupon = () => {
    if (coupon.trim().toUpperCase() === "FLORAISON") {
      setDiscountApplied(50000);
      alert("Áp dụng mã thành công! Bạn được giảm 50.000đ");
    } else {
      alert("Mã giảm giá không hợp lệ.");
    }
  };

  // --- HÀM KIỂM TRA ĐĂNG NHẬP & ĐÍNH KÈM STATE ĐIỀU HƯỚNG ---
  const handleNavigateToCheckout = () => {
    if (!auth.currentUser) {
      alert("Bạn cần đăng nhập tài khoản để tiến hành thanh toán đơn hàng! 🌸");
      // Truyền thông tin điểm đến tiếp theo vào state của router
      navigate("/dang-nhap", { state: { redirectTo: "/thanh-toan" } });
      return;
    }
    navigate("/thanh-toan");
  };

  return (
    <div style={styles.container}>
      <style>{`
        .btn-luxury-main {
          background-color: #222 !important;
          color: #fff !important;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .btn-luxury-main:hover {
          background-color: #000000 !important; /* Màu xanh rêu Floraison đặc trưng */
          transform: translateY(-1px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2) !important;
        }
        .btn-luxury-main:active {
          transform: translateY(0);
        }

        .btn-luxury-outline {
          background: transparent !important;
          border: 1px solid #000000 !important;
          color: #000000 !important;
          transition: all 0.3s ease;
        }
        .btn-luxury-outline:hover {
          background-color: #000000 !important;
          color: #fff !important;
        }

        .input-luxury-field:focus {
          border-color: #000000 !important;
          background-color: #ffffff !important;
        }

        .trash-btn-action {
          color: #bbb;
          transition: color 0.2s ease;
        }
        .trash-btn-action:hover {
          color: #000000 !important;
        }

        @media (max-width: 768px) {
          .cart-layout-flex {
            flex-direction: column !important;
          }
          .column-sticky-right {
            position: static !important;
          }
        }
      `}</style>

      <div style={styles.contentWrap}>
        <div style={styles.titleHeaderWrapper}>
          <span style={styles.scriptSubtitle}>Floraison</span>
          <motion.h1 
            initial={{ opacity: 0, y: -10 }} 
            animate={{ opacity: 1, y: 0 }} 
            style={styles.title}
          >
            <ShoppingBag size={24} color="#000000" strokeWidth={1.5} /> Giỏ hàng của bạn
          </motion.h1>
        </div>

        {cart.length === 0 ? (
          <div style={styles.emptyState}>
            <p style={styles.emptyText}>
              Giỏ hàng của bạn hiện đang trống, hãy quay lại chọn những mẫu thiết kế hoa tinh tế nhất nhé!
            </p>
            <button 
              className="btn-luxury-outline" 
              style={styles.btnAction} 
              onClick={() => navigate("/")}
            >
              Quay lại cửa hàng
            </button>
          </div>
        ) : (
          <div style={styles.cartLayout} className="cart-layout-flex">
            {/* CỘT TRÁI: DANH SÁCH GIỎ HÀNG CHÍNH */}
            <div style={styles.leftColumn}>
              <div style={styles.card}>
                <h2 style={styles.sectionTitle}>Các bó hoa nghệ thuật đã chọn</h2>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {cart.map((item, i) => (
                    <div
                      key={item.id || i}
                      style={{
                        display: "flex",
                        gap: "20px",
                        paddingBottom: "20px",
                        borderBottom: "1px solid rgba(74, 90, 58, 0.1)",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={item.img || (item.ma ? getFlowerImage(item.ma) : "https://images.unsplash.com/photo-1561181286-d3fee7d55364?w=150")}
                        alt={item.name}
                        style={{
                          width: "90px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "4px",
                          background: "#fafafa",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.04)"
                        }}
                      />
                      <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "6px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                          <h4 style={styles.itemName}>{item.name}</h4>
                          <button
                            className="trash-btn-action"
                            style={{ border: "none", background: "none", cursor: "pointer", padding: 0 }}
                            onClick={() => removeItem(item.id)}
                          >
                            <Trash2 size={16} strokeWidth={1.8} />
                          </button>
                        </div>
                        
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10 }}>
                          <div style={styles.quantityControl}>
                            <button style={styles.btnSmall} onClick={() => changeQuantity(item.id, -1)}>
                              −
                            </button>
                            <span style={styles.quantityNumberText}>
                              {item.quantity || 1}
                            </span>
                            <button style={styles.btnSmall} onClick={() => changeQuantity(item.id, 1)}>
                              +
                            </button>
                          </div>
                          <span style={styles.itemPrice}>
                            {((item.price || 0) * (item.quantity || 1)).toLocaleString()}đ
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                
                <button
  className="btn-luxury-outline" 
  style={{ ...styles.btnPrimary, marginTop: "28px" }} 
  onClick={handleNavigateToCheckout}
>
  Tiến hành thanh toán <ArrowRight size={15} style={{ marginLeft: 8 }} />
</button>
              </div>
            </div>

            {/* CỘT PHẢI: BẢN TỔNG HỢP CHI PHÍ (STICKY) */}
            <div style={styles.rightColumn} className="column-sticky-right">
              <div style={styles.stickySummary}>
                <h3 style={styles.summaryTitle}>Tóm tắt đơn hàng</h3>
                
                <div style={styles.couponSection}>
                  <input
                    type="text"
                    placeholder="Mã ưu đãi đặc quyền"
                    className="input-luxury-field"
                    style={styles.couponInput}
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                  />
                  <button className="btn-luxury-outline" style={styles.btnApplyCoupon} onClick={handleApplyCoupon}>
                    Áp dụng
                  </button>
                </div>

                <div style={styles.priceBreakdown}>
                  <div style={styles.priceRow}>
                    <span style={styles.labelMuted}>Giá trị tạm tính:</span>
                    <span style={styles.valueDark}>{subTotal.toLocaleString()}đ</span>
                  </div>
                  
                  {discountApplied > 0 && (
                    <div style={{ ...styles.priceRow, color: "#000000" }}>
                      <span style={styles.labelMuted}>Đặc quyền giảm giá:</span>
                      <span style={{ fontWeight: 500 }}>-{discountApplied.toLocaleString()}đ</span>
                    </div>
                  )}
                  
                  <div style={styles.priceRow}>
                    <span style={styles.labelMuted}>Phí vận chuyển:</span>
                    <span style={{ color: "#888", fontSize: "12px", fontStyle: "italic" }}>Tính ở bước kế tiếp</span>
                  </div>
                  
                  <div style={styles.totalOrderDivider}>
                    <span style={styles.totalFinalLabel}>Tổng số tiền</span>
                    <strong style={styles.totalFinalValue}>{finalTotalOrder.toLocaleString()}đ</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

/* ================= JSS STYLING CAO CẤP (PHONG CÁCH CHẾ TÁC FLORAISON) ================= */
const styles = {
  container: {
    fontFamily: '"Montserrat", sans-serif',
    background: "#fae6f4", // Đồng bộ màu nền Herosection thơ mộng quý phái
    minHeight: "100vh",
    paddingBottom: 60,
    color: "#222",
  },
  contentWrap: {
    maxWidth: 1140,
    margin: "0 auto",
    padding: "40px 20px",
  },
  titleHeaderWrapper: {
    textAlign: "center",
    marginBottom: "40px",
  },
  scriptSubtitle: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "36px",
    color: "#000000",
    display: "block",
    marginBottom: "-8px",
  },
  title: {
    fontFamily: '"Cormorant Garamond", serif',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    fontSize: "32px",
    fontWeight: 400,
    color: "#222",
    margin: 0,
    letterSpacing: "1px",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 20px",
    background: "#ffffff",
    borderRadius: "8px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
    border: "1px solid rgba(74, 90, 58, 0.1)",
  },
  emptyText: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "18px",
    color: "#555",
    marginBottom: "24px",
    lineHeight: "1.8",
  },
  btnAction: {
  padding: "14px 36px",
  fontFamily: '"Montserrat", sans-serif',
  fontSize: "12px",
  textTransform: "uppercase",
  letterSpacing: "2px",
  cursor: "pointer",
  background: "#ffffff",
  color: "#000000",
  border: "1px solid #000000",
  transition: "all 0.3s ease"
},
  cartLayout: {
    display: "flex",
    gap: "30px",
    alignItems: "flex-start",
  },
  leftColumn: {
    flex: "1 1 650px",
    display: "flex",
    flexDirection: "column",
  },
  rightColumn: {
    flex: "1 1 380px",
    position: "sticky",
    top: "40px",
  },
  card: {
    background: "#ffffff",
    padding: "35px 30px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.12)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.02)",
    boxSizing: "border-box",
  },
  sectionTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "22px",
    fontWeight: 500,
    color: "#222",
    marginBottom: "24px",
    marginTop: 0,
    letterSpacing: "0.5px",
  },
  itemName: {
    fontFamily: '"Cormorant Garamond", serif',
    margin: 0,
    fontSize: "18px",
    fontWeight: 500,
    color: "#222",
    lineHeight: "1.4",
  },
  itemPrice: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "15px",
    fontWeight: 500,
    color: "#000000",
  },
  btnPrimary: {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  padding: "15px 0",
  border: "1px solid #000000",
  fontFamily: '"Montserrat", sans-serif',
  fontSize: "13px",
  fontWeight: 500,
  textTransform: "uppercase",
  letterSpacing: "2px",
  cursor: "pointer",
  background: "#ffffff",
  color: "#000000",
},
  stickySummary: {
    background: "#ffffff",
    padding: "35px 30px",
    borderRadius: "4px",
    border: "1px solid rgba(74, 90, 58, 0.15)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.02)",
  },
  summaryTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    marginTop: 0,
    color: "#222",
    borderBottom: "1px solid rgba(74, 90, 58, 0.1)",
    paddingBottom: "14px",
    fontSize: "22px",
    fontWeight: 500,
    letterSpacing: "0.5px",
  },
  quantityControl: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #eaeaea",
    borderRadius: "2px",
    background: "#ffffff",
  },
  btnSmall: {
    width: "26px",
    height: "26px",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    fontSize: "14px",
    color: "#555",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  quantityNumberText: {
    width: "30px",
    textAlign: "center",
    fontSize: "13px",
    fontWeight: 500,
    color: "#222",
  },
  couponSection: {
    display: "flex",
    gap: "8px",
    margin: "20px 0",
    paddingBottom: "20px",
    borderBottom: "1px solid rgba(74, 90, 58, 0.1)",
  },
  couponInput: {
    flex: 1,
    padding: "10px 14px",
    border: "1px solid #eaeaea",
    borderRadius: "4px",
    fontSize: "13px",
    outline: "none",
    background: "#fafafa",
    fontFamily: '"Montserrat", sans-serif',
    transition: "all 0.3s ease",
  },
  btnApplyCoupon: {
    padding: "0 18px",
    borderRadius: "4px",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "1px",
    cursor: "pointer",
  },
  priceBreakdown: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  priceRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "14px",
  },
  labelMuted: {
    color: "#666",
    fontWeight: 300,
  },
  valueDark: {
    color: "#222",
    fontWeight: 500,
  },
  totalOrderDivider: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderTop: "1px solid rgba(74, 90, 58, 0.15)",
    paddingTop: "18px",
    marginTop: "10px",
  },
  totalFinalLabel: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "18px",
    fontWeight: 500,
    color: "#222",
    letterSpacing: "0.5px",
  },
  totalFinalValue: {
    fontFamily: '"Montserrat", sans-serif',
    color: "#000000",
    fontSize: "20px",
    fontWeight: 600,
  },
};